import { Navigate, useRoutes } from 'react-router-dom';
import { useMemo } from 'react';

import { PATH_AFTER_LOGIN } from 'src/config-global';
import { useAuthContext } from 'src/auth/hooks';

import { mainRoutes } from './main';
import { authRoutes } from './auth';
import { dashboardRoutes } from './dashboard';

// ----------------------------------------------------------------------

export default function Router() {

  const { user: dataUser } = useAuthContext();

  // const accessUser = useMemo(() => {
    
    if(dataUser) {
      const componentsAccessUser = dataUser?.routes?.map(ruta => {
        let components = [];
        if(ruta.subMenu) {
          components = ruta.subMenu.map((component) => (component.componente.toLowerCase()))
        }
        else {
          components = ruta.componente.toLowerCase();
        }
        return components;
      }).flat();
      
      dashboardRoutes[0].children = dashboardRoutes[0].children.filter((route) => componentsAccessUser?.includes(route.path?.toLowerCase()) || route.index === true || route.path === "publicas" )
      
    }
  // }, [dataUser]);

  
  return useRoutes([
    {
      path: '/',
      element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    },

    // Auth routes
    ...authRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    // Main routes
    ...mainRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
